export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"},{"name":"description","content":""},{"name":"msapplication-TileColor","content":"#2c9285"},{"name":"msapplication-config","content":"/favicon-dovista/browserconfig.xml"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/favicon-sf/apple-touch-icon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/favicon-sf/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/favicon-sf/favicon-16x16.png"},{"rel":"manifest","href":"/favicon-sf/site.webmanifest"},{"rel":"mask-icon","href":"/favicon-sf/safari-pinned-tab.svg","color":"#000000"},{"rel":"shortcut icon","href":"/favicon-sf/favicon.ico"}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtm.js?id=GTM-XXXXXXX","async":true},{"innerHTML":"window.dataLayer = window.dataLayer || [];\nfunction gtag(){dataLayer.push(arguments);}","type":"text/javascript"},{"src":"https://policy.app.cookieinformation.com/uc.js"}],"noscript":[],"htmlAttrs":{"lang":"en"},"title":"sf"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false